import React from 'react';
import { Info } from 'lucide-react';

/**
 * Pastille info : détail au survol / focus clavier.
 */
export default function FieldInfoTip({ label = 'Plus d’informations', children, className = '' }) {
  return (
    <span className={`relative inline-flex align-middle group ${className}`}>
      <button
        type="button"
        tabIndex={0}
        aria-label={label}
        className="inline-flex rounded-full p-0.5 text-indigo-500 hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-indigo-300"
      >
        <Info className="h-3.5 w-3.5" aria-hidden />
      </button>
      <span
        role="tooltip"
        className="pointer-events-none absolute left-1/2 bottom-[calc(100%+6px)] z-[60] w-72 max-w-[min(18rem,calc(100vw-2rem))] -translate-x-1/2 rounded-lg border border-gray-200 bg-white p-3 text-left text-xs leading-relaxed text-gray-700 shadow-lg opacity-0 transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100"
      >
        {children}
      </span>
    </span>
  );
}

export function FieldLabelWithTip({ htmlFor, children, tip, tipLabel }) {
  return (
    <label htmlFor={htmlFor} className="text-sm font-medium text-gray-700 mb-1 flex items-center gap-1.5">
      <span>{children}</span>
      {tip ? <FieldInfoTip label={tipLabel}>{tip}</FieldInfoTip> : null}
    </label>
  );
}
